import { render, staticRenderFns } from "./RatingQuestion.vue?vue&type=template&id=e62c836a&scoped=true"
import script from "./RatingQuestion.vue?vue&type=script&lang=js"
export * from "./RatingQuestion.vue?vue&type=script&lang=js"
import style0 from "./RatingQuestion.scss?vue&type=style&index=0&id=e62c836a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62c836a",
  null
  
)

export default component.exports